import { flow, onSnapshot, types } from 'mobx-state-tree';
import { IBookingAppointment, BookingClinic, BookingTimeslot } from './types';
import { Specialization } from 'entities/specializations/store/types';
import { axiosRequest } from 'shared/api';

export const ClinicModel = types.model({
	id: types.number,
	name: types.string,
});

const SlotModel = types.model({
	id: types.number,
	start: types.string,
	staff: types.number,
	branch: types.number,
});

export const BookingStore = types
	.model('BookingStore', {
		specialization: types.maybeNull(types.frozen()),
		clinics: types.array(ClinicModel),
		date: types.string,
		timeslot: types.maybeNull(SlotModel),
		doctorId: types.maybeNull(types.number),
    phone: types.maybeNull(types.string),
    isPhoneConfirmed: types.boolean,
    redirectFromDoctorPage: types.maybeNull(types.string)
	})
	.views(self => ({
		getClinicsNames: () => {
			return self.clinics.map(clinic => {
				return clinic.name;
			});
		},
		getSpecialization: () => {
			return self.specialization;
		},
		getDate: () => {
			return self.date;
		},
		getTimeslot: () => {
			return self.timeslot;
		},
		getDoctorId: () => {
			return self.doctorId;
		},
		getPhone: () => {
			return self.phone;
		},
    getIsPhoneConfirmed: () => {
      return self.isPhoneConfirmed;
    }
	}))
	.actions(self => ({
		setSpecialization(newSpecialization: Specialization) {
			self.specialization = newSpecialization;
			localStorage.setItem(
				'specialization',
				JSON.stringify(newSpecialization),
			);
		},
		setClinics(newClinics: BookingClinic[]) {
			self.clinics.replace(newClinics);
			localStorage.setItem('clinics', JSON.stringify(newClinics));
		},
		setDate(date: string) {
			self.date = date;
			localStorage.setItem('date', date);
		},
		removeDate() {
			self.date = '';
			localStorage.removeItem('date');
		},
		setTimeslot(bookingTimeslot: BookingTimeslot) {
			self.timeslot = bookingTimeslot;
			localStorage.setItem('timeslot', JSON.stringify(bookingTimeslot));
		},
		setDoctorId(doctorId: number) {
			self.doctorId = doctorId;
			localStorage.setItem('doctorId', String(doctorId));
		},
    setPhone(phone: string) {
      self.phone = phone;
			localStorage.setItem('phone', phone);
    },
    removePhone() {
      self.phone = null;
      localStorage.removeItem('phone')
      localStorage.removeItem('isPhoneConfirmed')
    },
    setIsPhoneConfirmed(val: boolean) {
      self.isPhoneConfirmed = val;
			localStorage.setItem('isPhoneConfirmed', String(val));
    },

    sendAppointment: flow(function* (payload: IBookingAppointment) {
      try {
        const answer = yield axiosRequest({
          path: '/api/v2/booking/appointment',
          method: 'post',
          params: payload
        });

        return answer;

      } catch (error) {
        console.warn('Error send appointment:' + error)
      }
    }),
    setRedirectFromDoctorPage(url: string | null) {
      self.redirectFromDoctorPage = url;
    }
	}));

export const bookingStore = BookingStore.create({
	specialization: null,
	clinics: [],
	date: '',
	timeslot: null,
  doctorId: null,
  phone: null,
  isPhoneConfirmed: false,
  redirectFromDoctorPage: null,
});

//Если нужно дебажить
onSnapshot(bookingStore, snapshot => {
  if (import.meta.env.VITE_SHOW_SNAPSHOT !== 'false') {
    console.log('Снимок состояния:', snapshot);
  }
});

// onAction(documentsStore, action => {
// 	console.log("Экшен", action);
// })
